<template>
  <Flex direction="column">
    <Flex
      :direction="$screen === 's' ? 'column' : 'row'"
      equalWidth
    >
      <BaseInput
        v-model="firstName"
        :label="$t('global.first_name')"
        required
        v-test="'customer-firstname'"
      />
      <BaseInput
        v-model="lastName"
        :label="$t('global.last_name')"
        required
        v-test="'customer-lastname'"
      />
    </Flex>
    <Flex
      :direction="$screen === 's' ? 'column' : 'row'"
      equalWidth
    >
      <BaseInput
        v-model="email"
        :label="$t('global.email_address')"
        type="email"
        v-test="'customer-email'"
      />
      <BaseInput
        v-model="phone"
        :label="$t('global.mobile_number')"
        type="tel"
        v-test="'customer-phone'"
      />
    </Flex>
    <AddressFields
      v-if="requireAddress"
      v-model:address="address"
      v-model:zipcode="zipcode"
      v-model:city="city"
      required
    />
    <Flex
      v-if="requireMedicalData"
      :direction="$screen === 's' ? 'column' : 'row'"
      equalWidth
    >
      <BaseInput
        v-model="dateOfBirth"
        :label="$t('global.date_of_birth')"
        type="date"
        v-test="'customer-birthday'"
      />
      <BaseInput
        v-model="personalRegistrationNumber"
        :label="$t('global.personal_registration_number')"
        type="text"
        v-test="'customer-bsn'"
      />
    </Flex>
    <BaseInput
      v-if="requireMedicalData"
      v-model="insuranceProvider"
      :label="$t('global.insurance_provider')"
      type="text"
      v-test="'customer-insurance-provider'"
    />
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import AddressFields from '@/components/_shared/address-fields/index.vue';

const props = withDefaults(
  defineProps<{
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address?: string;
    zipcode?: string;
    city?: string;
    dateOfBirth?: string;
    personalRegistrationNumber?: string;
    insuranceProvider?: string;
    requireAddress?: boolean;
    requireMedicalData?: boolean;
  }>(),
  {
    requireAddress: false,
    requireMedicalData: false,
  },
);

const emit = defineEmits<{
  (e: 'update:firstName', value: string): void;
  (e: 'update:lastName', value: string): void;
  (e: 'update:email', value: string): void;
  (e: 'update:phone', value: string): void;
  (e: 'update:address', value: string): void;
  (e: 'update:zipcode', value: string): void;
  (e: 'update:city', value: string): void;
  (e: 'update:dateOfBirth', value: string): void;
  (e: 'update:personalRegistrationNumber', value: string): void;
  (e: 'update:insuranceProvider', value: string): void;
}>();

const firstName = computed({
  get: () => props.firstName,
  set: (value) => emit('update:firstName', value),
});

const lastName = computed({
  get: () => props.lastName,
  set: (value) => emit('update:lastName', value),
});

const email = computed({
  get: () => props.email,
  set: (value) => emit('update:email', value),
});

const phone = computed({
  get: () => props.phone,
  set: (value) => emit('update:phone', value),
});

const address = computed({
  get: () => props.address,
  set: (value) => emit('update:address', value),
});

const zipcode = computed({
  get: () => props.zipcode,
  set: (value) => emit('update:zipcode', value),
});

const city = computed({
  get: () => props.city,
  set: (value) => emit('update:city', value),
});

const dateOfBirth = computed({
  get: () => props.dateOfBirth,
  set: (value) => emit('update:dateOfBirth', value),
});

const personalRegistrationNumber = computed({
  get: () => props.personalRegistrationNumber,
  set: (value) => emit('update:personalRegistrationNumber', value),
});

const insuranceProvider = computed({
  get: () => props.insuranceProvider,
  set: (value) => emit('update:insuranceProvider', value),
});
</script>
